<div>
  <video id="preview-video" autoplay #previewVideo></video>
</div>

<div>
  <video id="raw-preview-video" autoplay #rawPreviewVideo></video>
</div>

<div>
  <video id="hd-preview-video" autoplay #hdPreviewVideo></video>
</div>
